<button (click)="telecharger()">télécharger</button>